import {
  Gauge,
  Route,
  BarChart3,
  Trophy,
} from "lucide-react";
import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { useRouteSummary } from "../../hooks";

export const KpiCards = () => {
  const { data: summaryData } = useRouteSummary();

  const stats = [
{
  title: "Total Routes",
  count: summaryData?.totalRoutes,
  tooltip: (
    <div className="text-sm max-w-xs">
      <ul className="list-disc pl-4 space-y-1">
        <li>
          <strong>Definition:</strong> Total number of routes created for meter reading within the current filters.
        </li>
        <li>
          <strong>Optimisation Insight:</strong> Understand total operational workload and scale. Track against targets or cycles.
        </li>
        <li>
          <strong>Calculation:</strong> Count of all routes created.
        </li>
      </ul>
    </div>
  ),
  icon: <Route  className="h-8 w-8 text-blue-500" />,
}
,
{
  title: "Average Meters per Route",
  count: summaryData?.avgMetersPerRoute,
  tooltip: (
    <div className="text-sm max-w-xs">
      <ul className="list-disc pl-4 space-y-1">
        <li>
          <strong>Definition:</strong> The average number of meters assigned to each route.
        </li>
        <li>
          <strong>Optimisation Insight:</strong> Assess workload distribution. Large deviations suggest unbalanced routes.
        </li>
        <li>
          <strong>Calculation:</strong> Total meters ÷ total routes.
        </li>
      </ul>
    </div>
  ),
  icon: <Gauge className="h-8 w-8 text-green-500"  />,
}
,
   {
  title: "Route with Highest Meters",
  count: summaryData?.routeWithHighestMetersCount,
 trendSummary:summaryData?.routeWithHighestMetersName ,
  tooltip: (
    <div className="text-sm max-w-xs">
      <ul className="list-disc pl-4 space-y-1">
        <li>
          <strong>Definition:</strong> The route containing the largest number of meters and its meter count.
        </li>
        <li>
          <strong>Optimisation Insight:</strong> Identify workload hotspots. Consider splitting overly heavy routes.
        </li>
        <li>
          <strong>Calculation:</strong> Route with maximum meter count among all routes.
        </li>
      </ul>
    </div>
  ),
  icon: <Trophy className="h-8 w-8 text-orange-500" />,
},
    {
  title: "Total Meters Covered",
  count: summaryData?.totalMetersCoveredInRoutes,
  tooltip: (
    <div className="text-sm max-w-xs">
      <ul className="list-disc pl-4 space-y-1">
        <li>
          <strong>Definition:</strong> Total number of meters mapped into all created routes.
        </li>
        <li>
          <strong>Optimisation Insight:</strong> Indicates overall coverage. Low coverage suggests unassigned meters.
        </li>
        <li>
          <strong>Calculation:</strong> Sum of meters across all routes.
        </li>
      </ul>
    </div>
  ),
  icon: <BarChart3 className="h-8 w-8 text-blue-500"  />,
}

  ];

  return (
    <div>
      {/* Quick Stats Section */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
        {stats.map((item, index) => (
          <QuickStatsCard
            key={index}
            title={item.title}
            count={item.count}
            icon={item.icon}
            tooltip={item.tooltip}
            trendSummary={item.trendSummary}
          />
        ))}
      </div>
    </div>
  );
};
